const isShimmLoaded = Boolean(globalThis.importShim);

export default async function ensureDynamicImport<T>(moduleName: string): Promise<T> {
  if (isShimmLoaded) {
    return await importShim<T>(moduleName);
  } else {
    return await importModule(moduleName);
  }
}

export function isShimLoaded(): boolean {
  return isShimmLoaded;
}
